export const IS_PRODUCTION: boolean = process.env.NODE_ENV === "production";
